<template>
  <div>
    <div class="modal">
      <div class="modal__header">
        <img src="/static/img/pictos/reappro.svg" class="picto"> <span>Mon réappro</span> <a href="" @click.prevent="closeModal()"><img class="close" src="/static/img/pictos/fermer-bleu.svg"></a>
      </div>
      <ProductReapproModal :item="item" @min="setMin" @max="setMax"></ProductReapproModal>
      <div class="modal__btns">
        <a href="" class="modal__btn modal__btn--valid"  @click.prevent="validAddReappro(item.id)">
          <span>Ajouter au réappro</span>
          <img src="/static/img/pictos/reappro.svg" class="">
        </a>
      </div>
    </div>
    <div class="overlay" @click.prevent="closeModal()">
      <i></i>
    </div>
  </div>
</template>

<script>
import ProductReapproModal from "@/components/Product/ProductReapproModal";

export default {
  name: "ReapproAddModal",
  props: [
    "item",
  ],
  data() {
    return {
      min: 1,
      max: 10
    }
  },
  components: {
    ProductReapproModal
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    closeModal(){
      this.$emit("close")
    },
    setMin(min){
      this.min = min
    },
    setMax(max){
      this.max = max
    },
    validAddReappro(id){
      const self = this;

      if(this.min >= 0 && this.max >= 1 && (this.min < this.max)){
        this.$http.post('vehiclestock/addReappro', {
          restocking: 1,
          validated: 0,
          product: {
            id: id
          },
          minStock: this.min,
          maxStock: this.max
        }).then(response => {
          this.$toastr.success(this.$i18n.t("success.reappro.added"));
          self.closeModal()
        })
      }else{
        this.$toastr.error(this.$i18n.t("error.reappro.min_superior_max"));
      }

    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: white;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: white;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(25, 45, 85, 0.95);
    z-index: 800;
  }

  .modal { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);  height: 425px; width: 50%; min-width: 400px; z-index: 900; text-align: center; display: flex; flex-direction: column;
    &__header{ margin-top: 0; background-color: $color4; width: 100%; color: white; display: flex; align-items: center; justify-content: flex-start; height: 75px;
      .picto{ width: 50px; margin-left: 20px; }
      span{ justify-self: flex-start; font-family: 'ClanFFBlack'; font-size: 18px; text-transform: uppercase; margin-left: 20px; margin-top: 4px; }
      a{ margin-right: 20px; margin-left: auto; }
      .close{ width: 20px; }
    }
    &__title{ font-family: 'ClanFFBlack'; font-size: 20px; color: $color1; margin-top: auto; }
    &__picto{ width: 120px; margin-top: 20px; margin-bottom: auto; }
    &__btns{ display: flex; height: 50px; width: 100%; position: absolute; bottom: 0; right: 0; justify-content: flex-end; }
    &__btn{ width: 50%; height: 100%; display: flex; align-items: center; justify-content: center; background-color: $color4;
      img{ width: 30px; }
      span{ font-family: 'ClanProBold'; font-size: 12px; color: white; margin-right: 10px; }
      &:hover{ text-decoration: none; }
    }
    @media screen and (max-width: 400px){ min-width: 300px;
      width: calc(100% - 20px);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproAddModal.vue